import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import NavbarButton from './NavBarButton';
import Styles from './index.module.css';

const buttonEntities = [
  {
    pageName: '我的廣告',
    routeKey: 'MyAds',
  },
  {
    pageName: '帳戶儲值',
    routeKey: 'TopUp',
  },
  {
    pageName: '投資成效',
    routeKey: 'INV',
  },
  {
    pageName: '常見問題',
    routeKey: 'FQA',
  },
];
function NavBar() {
  const history = useHistory();

  const onClick = (routeKey) => {
    history.push(`/${routeKey}`);
  };

  return (
    <div className={Styles.container}>
      {buttonEntities.map(({ pageName, routeKey }, index) => (
        index !== buttonEntities.length - 1 ? (
          <div key={pageName} className={Styles.buttonItem}>
            <NavbarButton
              text={pageName}
              routeKey={routeKey}
              onClick={onClick}
              curRoute={history.location.pathname}
            />
          </div>
        ) : (
          <a href="https://www.hhgalaxy.com.tw/qa" target="_blank" rel="noopener noreferrer" key={pageName} className={Styles.buttonItem}>
            <NavbarButton
              text={pageName}
            />
          </a>
        )
      ))}
    </div>
  );
}

export default memo(NavBar);
